import React from "react";
import ReactCodeInput from "react-verification-code-input";
import classnames from "classnames";

export default class ConfirmationCode extends React.PureComponent {

  render() {
    const { onChange, disabled, fields, className, ...rest } = this.props;

    return (
      <ReactCodeInput
        fields={fields}
        onChange={onChange}
        disabled={disabled}
        autoFocus
        className={classnames(className, "test")}
        {...rest}
      />
    );
  }

}
